/**
 * Created by eliana.centamore.
 */

"use strict";

require("Pages/sepaio.css");
require("Base/init");
const App = require("CommonClientServer/Base/app");

App.extend({
        init (method, model, options) {
            $('.sepaio-logo[data-toggle="tooltip"]').tooltip();
        }
    })
    .init();
